import moment from 'moment';
import { NORMALIZED_PATTERN } from '@/utils/date';

export function setQueryParameterInURL({ paramKey, paramValue } = {}) {
  if (!paramKey || !paramValue) {
    throw new Error('"paramKey" and "paramValue" are required.');
  }

  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set(paramKey, paramValue);
  history.pushState(null, null, `?${queryParams.toString()}`);
}

export const displaceDateRange = (params) => {
  const [from, to] = params.date_range
    .split(':')
    .map(date => moment(date, NORMALIZED_PATTERN));

  const displacedSecs = to.diff(from, 'seconds');

  const displacedTo = from
    .subtract(1, 'minutes')
    .format(NORMALIZED_PATTERN);

  const displacedFrom = from
    .subtract(displacedSecs, 'seconds')
    .format(NORMALIZED_PATTERN);

  const displacedDateQueryFormat = `${displacedFrom}:${displacedTo}`;

  return {
    originalParams: params,
    displacedParams: { ...params, date_range: displacedDateQueryFormat },
  };
};

export function getWarroomURL(isStaging, accountId, universeId) {
  const warroomEnviroment = isStaging ? 'https://warroom-test.com.br' : 'https://warroom.stilingue.com.br';
  return `${warroomEnviroment}/ativarcontapesquisa/${accountId}/${universeId}`;
}

export function getSmartCareURL(isStaging, dateRange, filterId) {
  const smartCareEnviroment = isStaging ? 'https://smartcare.warroom-test.com.br' : 'https://smartcare.stilingue.com.br';
  return `${smartCareEnviroment}/conversas/minhasconversas/?date_range=${dateRange}&filters=${filterId}`;
}
